import { Box } from "@mui/material";
import ThemeSettings from "src/components/ThemeSettings/index";
import SupportChat from "src/components/SupportChat";
// import HeaderNotifications from "./Notifications";
// import Chat from "./Chat";

function HeaderButtons() {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {/* <Chat /> */}
      {/* <HeaderNotifications /> */}
      {/* <LanguageSwitcher /> */}
      <SupportChat />
      <ThemeSettings />
    </Box>
  );
}

export default HeaderButtons;
